// extracted by mini-css-extract-plugin
module.exports = {"notice":"notice_notice__ENnIu","unread":"notice_unread__bH5mE"};